import type { IconSvgObject } from './types';

const ParallelogramIcon: IconSvgObject = [
  ["path", { d: "M2.31062 18.7575L5.81062 4.75746C5.92192 4.3123 6.3219 4 6.78077 4H20.7192C21.3698 4 21.8471 4.61139 21.6894 5.24254L18.1894 19.2425C18.0781 19.6877 17.6781 20 17.2192 20H3.28077C2.6302 20 2.15284 19.3886 2.31062 18.7575Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ParallelogramIcon;
